import Vue from 'vue'
import { router } from './routing'

// VueBulma
import VueBulma from '@billow/vue-bulma'
import './providers/fontawesome'
import * as zondicons from '@/providers/zondicons'
Vue.use(VueBulma, {
  config: {
    icons: {
      pack: 'zondicons',
      zondicons
    },
    components: {
      fieldLabel: {
        hintIconPack: 'zondicons',
        hintIcon: 'information-solid',
      },
      pager: {
        buttonIconPack: 'zondicons',
        prevButtonIcon: 'arrow-thin-left',
        nextButtonIcon: 'arrow-thin-right',
      }
    }
  }
})

// JsHelpers
import { filters, stores, mixins } from '@billow/js-helpers'
import { store } from './store'
Vue.use(filters)
Vue.use(stores, { store })
Vue.mixin(mixins.errors)

// Toasty toast
import Toast from '@billow/toast'
Vue.use(Toast, {
  types: Toast.types,
  namespaced: true
})

// Status Indicator
import StatusIndicator from 'vue-status-indicator';
Vue.use(StatusIndicator);

// Text editor
import Redactor from './redactor'
import './redactor/plugins/video'
import './redactor/plugins/counter'
import './redactor/plugins/fullscreen'
Vue.use(Redactor)

// Easy Route

import EasyRoute from '@billow/easy-route'

Vue.use(EasyRoute, {
  router,
  guards: [

  ]
})

// Modals
import * as Modals from 'vue-modal-dialogs'
Vue.use(Modals)
import '@/modals'

// Vue slicksort
import { ContainerMixin, ElementMixin } from 'vue-slicksort';
Vue.use(ContainerMixin)
Vue.use(ElementMixin)

// Vue Clipboard
import VueClipboard from 'vue-clipboard2'
Vue.use(VueClipboard)
